import { styled } from 'baseui'

export const RequiredMark = styled('span', ({ $theme }) => ({
  color: $theme.colors.errorInput,
}))
